import React, {useEffect} from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import ModalDialog from '../../../shared/components/modals/modal-dialog/modal-dialog'
import Button from '../../../shared/components/atoms/button/button'
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'
import './modal-sample-info.scss'

const ModalSampleInfo = ({ onClose, onClickButton }) => {
  const {
    allContentfulVConfidentMuestraGratis: { nodes: content },
  } = useStaticQuery(graphql`
    {
      allContentfulVConfidentMuestraGratis(
        filter: { slug: { eq: "muestra-gratis/" } }
      ) {
        nodes {
          paisesDeRestriccion
          node_locale
          popUpImagenKit {
            gatsbyImageData
          }
          popUpInformacionRecibiras {
            raw
          }
          popUpInformacionKit {
            raw
          }
          popUpSellosRelacionados {
            descripcinComponente {
              raw
            }
            imagenComponente {
              file {
                url
              }
            }
          }
        }
      }
    }
  `)

  const dataLayerModal = () => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Pop-ups_VConfident',
      category: 'v-confident',
      action: 'view',
      label: 'Kit V-Confident',
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  const dataLayerModalButton = () => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Pop-ups_VConfident',
      category: 'v-confident',
      action: 'click',
      label: 'Pedir muestra',
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  useEffect(() => {
    dataLayerModal()
  }, [])
  

  const info = content.filter(
    e =>
      e.node_locale === 'es-CO' &&
      !e.paisesDeRestriccion?.includes(process.env.LOCALE)
  )[0]

  return (
    <ModalDialog
      noScroll
      onClose={onClose}
      className="f-modal-sample-info-scroll"
      content={
        <div className="f-modal-sample-info">
          <GatsbyImage
            image={getImage(info.popUpImagenKit[0])}
            className="f-modal-sample-info__img"
            objectFit="contain"
          />
          <div className="f-modal-sample-info__description">
            {documentToReactComponents(
              JSON.parse(info.popUpInformacionKit.raw)
            )}
          </div>

          <div className="f-sample-info-seal">
            {info.popUpSellosRelacionados.map(sello => (
              <div className="f-seal">
                <img
                  src={sello.imagenComponente[0].file.url}
                  alt={sello.titulo}
                  width={50}
                  height={50}
                  className="f-seal__img"
                />
                {documentToReactComponents(
                  JSON.parse(sello.descripcinComponente.raw)
                )}
              </div>
            ))}
          </div>

          <div className="f-info-recive">
            {documentToReactComponents(
              JSON.parse(info.popUpInformacionRecibiras.raw)
            )}
          </div>
          <p className="f-modal-sample-info__footer">
            Este producto está diseñado para mujeres de{' '}
            <b> 40 años en adelante </b>. Si aún no estás en esta etapa de tu
            vida, te invitamos a conocer nuestras otras líneas.
          </p>
          <div className="f-button-container">
            <Button
              text="Pedir muestra"
              color="purple"
              action={ () => {
                dataLayerModalButton()
                onClickButton()
              }}
            />
          </div>
        </div>
      }
    />
  )
}

export default ModalSampleInfo
